import axios from 'axios';

class Api {
    _baseApi = '/api/';

    async getLessValidation(less) {
        const request = {
            Less: less,
        };
        return axios.post(`${this._baseApi}less/validation`, request);
    }

    async createCustomCss(cssRequest) {
        return axios.post(`${this._baseApi}less/custom-css`, cssRequest);
    }

    getCustomCssUrl(key) {
        return `${location.protocol}//${location.host}${this._baseApi}less/custom-css/${key}`;
    }

    async createZip(request) {
        return axios.post(`${this._baseApi}pack`, request);
    }

    async getZip(key) {
        return axios.get(`${this._baseApi}pack/${key}.zip`);
    }

    async sendMail(request) {
        return axios.post(`${this._baseApi}send-mail`, request);
    }
}

const ApiInstance = new Api();
export default ApiInstance;
export { Api, ApiInstance };
